'use strict';
require('./Tabs.scss');

const React = require('react');
const {t} = require('services/i18nextWrapper');
const {TextField, IconButton, CircularProgress} = require('material-ui');
const CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');
const get = require('lodash/object').get;

const Tabs = React.createClass({displayName: "Tabs",
  
  propTypes: {
    isLoading: React.PropTypes.bool,
    activeIndexTab: React.PropTypes.number,
    fetchList: React.PropTypes.func,
    onSaveChangedTab: React.PropTypes.func,
    onSaveNewTab: React.PropTypes.func,
    onDeleteExistingTab: React.PropTypes.func,
    onChangeTab: React.PropTypes.func,
    children: React.PropTypes.any
  },
  
  getInitialState() {
    return {
      indexTabActive: this.props.activeIndexTab || 0,
      isEditMode: false
    };
  },
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.activeIndexTab !== this.props.activeIndexTab) {
      this.setState({ indexTabActive: nextProps.activeIndexTab });
    }
  },
  
  fetchList() {
    this.props.fetchList();
  },
  
  onAddNewTab(newName) {
    this.props.onSaveNewTab(newName, this.state.indexTabActive);
  },
  
  onChangeExistingTab(tabId, changedName, originalName) {
    this.props.onSaveChangedTab(tabId, changedName, originalName, this.state.indexTabActive);
  },
  
  onDeleteExistingTab(id, listName) {
    this.props.onDeleteExistingTab(id, listName);
  },
  
  render() {
    const {children, isLoading} = this.props;
    const {indexTabActive, isNewMode, isEditMode} = this.state;
    const self = this;
    const getTabsHeader = (indexTabActive) => (
      React.createElement("div", {className: "bp-tabs__header", id: "tab-header-id"}, 
        children && React.Children.map(children.filter(child => child), (child, tabIndex) => {
          return (
            React.createElement("div", {
              key: `child-id-${child && child.props && child.props.id}`, 
              className: `bp-tab-header${tabIndex === indexTabActive ? ' is-active' : ''}`, 
              onClick: (evt) => {
                if (evt) evt.preventDefault();
                self.setState(prevState => {
                  return {
                    indexTabActive: tabIndex,
                    isEditMode: prevState.indexTabActive === tabIndex,
                    isNewMode: false
                  };
              }, () => this.props.onChangeTab());
              }
            }, 
              
                tabIndex === indexTabActive && isEditMode
                  ? React.createElement(EditModeTab, {
                    label: child.props.label, 
                    onClose: () =>
                      self.setState({
                        isEditMode: false,
                        isNewMode: false
                      }), 
                    onSave: (changedName) => self.setState({
                      isEditMode: false,
                      isNewMode: false
                    }, () => self.onChangeExistingTab(child.props.id, changedName, child.props.label)), 
                    onDelete: () => self.setState(() => ({
                      isEditMode: false,
                      isNewMode: false
                    }), () => self.onDeleteExistingTab(child.props.id, child.props.label))}
                  )
                  : get(child, 'props.label')
              
            )
          );
        }), 
        React.createElement("div", {className: "bp-tabs__header--new-list"}, 
          
          !isNewMode && React.createElement(IconButton, {
            onClick: () => this.setState(prevState => ({isNewMode: !prevState.isNewMode, isEditMode: false})), 
            iconClassName: "material-icons", 
            backgroundColor: "lightgray"}, 
            "add_circle_outline"
          ), 
          
          isNewMode && React.createElement(NewModeTab, {
            onClose: () => this.setState(prevState => ({isNewMode: !prevState.isNewMode, isEditMode: false})), 
            onSave: (newName) => this.onAddNewTab(newName)}
          )
        )
      )
    );

    return (
      React.createElement("div", {className: "bp-tabs"}, 
        isLoading && React.createElement("div", {className: "bp-tabs__loading"}, React.createElement(CircularProgress, {mode: "indeterminate", size: 1.5})), 
        getTabsHeader(indexTabActive), 
        React.createElement("div", {className: "bp-tabs__body"}, 
          React.Children.map((children || []).filter(child => child), (childTab, tabIndex) => {
            return childTab && React.cloneElement(childTab, {
              'isActive': tabIndex === indexTabActive,
              'isEditMode': tabIndex === indexTabActive && isEditMode,
              tabIndex,
              key: `tab-index-${tabIndex}`
            });
          })
        )
      )
    );
  }
});

const NewModeTab = React.createClass({displayName: "NewModeTab",
  
  getInitialState() {
    return {
      listName: ''
    };
  },
  
  onKeyPressOverInput(evt) {
    if (evt.charCode === 13) {
      this.props.onSave(evt.target.value);
      this.props.onClose();
    }
  },
  
  componentDidMount() {
    if (this._inputEl)
      this._inputEl.focus();
  },
  
  refCallback(el) {
    if (el)
      this._inputEl = el;
  },
  
  render() {
    const {onClose, onSave} = this.props;
    const {listName} = this.state;
    return (
      React.createElement("div", {className: "bp-tabs__header--new-mode", onClick: (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
      }}, 
        React.createElement(TextField, {
          ref: this.refCallback, 
          floatingLabelText: t('dashboard_user_task_list_name'), 
          onBlur: (evt) => this.setState({listName: evt.target.value}), 
          onKeyPress: this.onKeyPressOverInput}
        ), 
        React.createElement(IconButton, {
          onClick: onClose, 
          iconClassName: "material-icons", 
          backgroundColor: "lightgray"}, 
          "close"
        ), 
        React.createElement(IconButton, {
          onClick: () => {
            onSave(listName);
            onClose();
          }, 
          iconClassName: "material-icons", 
          backgroundColor: "lightgray"}, 
          "save"
        )
      )
    );
  }
});

const EditModeTab = React.createClass({displayName: "EditModeTab",
    
    getInitialState() {
      return {
        listName: this.props.label
      };
    },
    
    componentDidMount() {
      if (this._inputEl)
        this._inputEl.focus();
    },
    
    refCallback(el) {
      if (el)
        this._inputEl = el;
    },
  
    onKeyPressOverInput(evt) {
        if (evt.charCode === 13) {
          this.props.onSave(evt.target.value);
          this.props.onClose();
        }
    },
    
    render() {
      const {label, onClose, onSave, onDelete} = this.props;
      const {listName} = this.state;
      
      return (
        React.createElement("div", {className: "bp-tabs__header--edit-mode", onClick: (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
        }}, 
          React.createElement(TextField, {
            ref: this.refCallback, 
            defaultValue: label, 
            onBlur: (evt) => this.setState({listName: evt.target.value}), 
            onKeyPress: this.onKeyPressOverInput}
          ), 
          React.createElement(IconButton, {
            onClick: () =>
              CustomDialog.showWarningConfirmation(t('warning'), t('notification_confirm_delete_user_list_tasks'), () => {
                onClose();
                onDelete();
              }), 
            
            iconClassName: "material-icons", 
            backgroundColor: "lightgray"}, 
            "delete"
          ), 
          React.createElement(IconButton, {
            onClick: onClose, 
            iconClassName: "material-icons", 
            backgroundColor: "lightgray"}, 
            "close"
          ), 
          React.createElement(IconButton, {
            onClick: () => onSave(listName), 
            iconClassName: "material-icons", 
            backgroundColor: "lightgray"}, 
            "save"
          )
        )
      );
    }
  }
);


const Tab = React.createClass({displayName: "Tab",
  render() {
    const {children, isActive, isEditMode} = this.props;
    return (
      React.createElement("div", {className: 'bp-tab' +
      (isActive ? ' is-active' : '') +
      (isEditMode ? 'is-edit-mode' : '')
      }, 
        children
      )
    );
  }
});

module.exports = {
  Tab,
  Tabs
};


/** WEBPACK FOOTER **
 ** ./src/components/Tabs/Tabs.jsx
 **/